import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path:'sso',
    loadChildren: () => import('./ui/sso/sso.module').then(m=>m.SsoModule),
    pathMatch:'full'
  },
  {
    path:'login',
    loadChildren: () => import('./ui/login/login.module').then(m=>m.LoginModule),
    pathMatch:'full'
  },
  {
    path:'recover',
    loadChildren: () => import('./ui/recover-password/recover-password.module').then(m => m.RecoverPasswordModule)
  },
  {
    path:'',
    redirectTo:'login',
    pathMatch:'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
